import { Modal } from '@bp/ui-components';
import { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SubstitutionDataEntry,
  SubstitutionTimetableEntry,
} from '../../../pages/Substitutions/Plan/PlanSubstitutions/utils';
import { MergeEventForm } from '../forms/MergeEventForm';

type MergeEventModalProps = {
  isOpen: boolean;
  originTeachers: SubstitutionDataEntry[];
  originRooms: SubstitutionDataEntry[];
  substitutionComment: string;
  eventStart: Dayjs;
  eventEnd: Dayjs;
  eventUuid: string;
  timetableStart: Dayjs;
  timetableEnd: Dayjs;
  timetableEntries: SubstitutionTimetableEntry[];
  onClose: () => void;
};

export const MergeEventModal = ({
  isOpen,
  originTeachers,
  originRooms,
  eventStart,
  eventEnd,
  eventUuid,
  timetableStart,
  timetableEnd,
  timetableEntries,
  substitutionComment,
  onClose,
}: MergeEventModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} title={t('substitutions.mergeEvent')} isOpen={isOpen} onRequestClose={onClose}>
      <MergeEventForm
        originTeachers={originTeachers}
        originRooms={originRooms}
        eventStart={eventStart}
        eventEnd={eventEnd}
        eventUuid={eventUuid}
        timetableStart={timetableStart}
        timetableEnd={timetableEnd}
        timetableEntries={timetableEntries}
        substitutionComment={substitutionComment}
        onLoad={setLoading}
        onClose={onClose}
      />
    </Modal>
  );
};
